module.exports = __webpack_public_path__ + "static/media/Background_PaymentPage_Tutor.291020fe.svg";